export const LinesSpinner = ({ className }) => {
  return (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_6772_139229)">
      <path
        d="M12 3V6"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H18"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3638 18.3638L16.2422 16.2422"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21V18"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.63672 18.3638L7.75828 16.2422"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12H6"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.63672 5.63672L7.75828 7.75828"
        stroke="white"
        strokeWidth={1.125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6772_139229">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
  );
};
